import { useState } from 'react';
import moment from 'moment-timezone';
import DatePicker from 'common/components/form/DatePicker';
import { convertStringToMoment } from 'common/utils/date-time';
import { DataGridFilter } from 'common/types/datagrid';
import styles from './DateBeforeAfter.module.scss';

interface DateBeforeAfterProps {
    onBeforeDateChange: (date: moment.Moment) => void;
    onAfterDateChange: (date: moment.Moment) => void;
    openDirection?: string;
    openDirectionAfter?: string;
    openDirectionBefore?: string;
    beforeDateFilter?: DataGridFilter;
    afterDateFilter?: DataGridFilter;
    anchorDirectionBefore?: string;
    anchorDirectionAfter?: string;
    beforeLabel?: string;
    afterLabel?: string;
    prefixControlId?: string;
    containerColumn?: boolean;
    disabled?: boolean;
    usePortal?: boolean;
}

const DateBeforeAfter = ({
    beforeDateFilter,
    afterDateFilter,
    onBeforeDateChange,
    onAfterDateChange,
    anchorDirectionBefore,
    anchorDirectionAfter,
    containerColumn,
    disabled,
    beforeLabel,
    afterLabel,
    openDirectionAfter,
    openDirectionBefore,
    openDirection = 'down',
    prefixControlId = 'advanced-filter-date',
    usePortal = false,
}: DateBeforeAfterProps) => {
    const [beforeFocus, setBeforeFocus] = useState<boolean>(false);
    const [afterFocus, setAfterFocus] = useState<boolean>(false);

    const yearMin = moment().year() - 3;

    return (
        <div
            className={
                containerColumn ? styles.containerColumn : styles.containerRow
            }
        >
            <div className={styles.content}>
                <label className={styles.label}>{beforeLabel || 'After'}</label>
                <DatePicker
                    id={`${prefixControlId}-after-select`}
                    dataTestId={`${prefixControlId}-after-select`}
                    date={afterDateFilter ? afterDateFilter.term : null}
                    isDayBlocked={(day: moment.Moment) =>
                        day >=
                        convertStringToMoment(beforeDateFilter?.term as string)
                    }
                    onDateChange={onAfterDateChange}
                    hideKeyboardShortcutsPanel
                    numberOfMonths={1}
                    focused={afterFocus}
                    onFocusChange={({ focused }: { focused: boolean }) =>
                        setAfterFocus(focused)
                    }
                    placeholder='Select...'
                    isOutsideRange={() => false}
                    openDirection={openDirectionAfter || openDirection}
                    showClearDate
                    yearMin={yearMin}
                    anchorDirection={anchorDirectionBefore}
                    disabled={disabled}
                    fixedPortal={usePortal}
                    usePortal={usePortal}
                />
            </div>
            <div className={styles.content}>
                <label className={styles.label}>{afterLabel || 'Before'}</label>
                <DatePicker
                    id={`${prefixControlId}-before-select`}
                    dataTestId={`${prefixControlId}-before-select`}
                    date={beforeDateFilter ? beforeDateFilter.term : null}
                    isDayBlocked={(day: moment.Moment) =>
                        day <=
                        convertStringToMoment(afterDateFilter?.term as string)
                    }
                    onDateChange={onBeforeDateChange}
                    hideKeyboardShortcutsPanel
                    numberOfMonths={1}
                    focused={beforeFocus}
                    onFocusChange={({ focused }: { focused: boolean }) =>
                        setBeforeFocus(focused)
                    }
                    placeholder='Select...'
                    isOutsideRange={() => false}
                    openDirection={openDirectionBefore || openDirection}
                    showClearDate
                    yearMin={yearMin}
                    anchorDirection={anchorDirectionAfter}
                    disabled={disabled}
                    fixedPortal={usePortal}
                    usePortal={usePortal}
                />
            </div>
        </div>
    );
};

export default DateBeforeAfter;
